import useUser from './useUser';

import { useNavigate } from 'react-router-dom';
import Paths from '@/routes/paths';
import { destroyUserCache } from '@/lib/storageUtil';

const useLogout = (): (() => void) => {
  const { setUser } = useUser();

  const navigate = useNavigate();

  const logout = () => {
    setUser(null);

    destroyUserCache();
    navigate(Paths.LoginPage);
  };

  return logout;
};

export default useLogout;
